module.exports = __webpack_public_path__ + "./fonts/Guardian-Semibold.ttf";